module.exports = __webpack_public_path__ + "img/codelab-logo.bd88f77c.png";